export { default } from "@src/Apps/Prism";
